import React from 'react';
import './Footer.css';
import logo from '../assets/Logo_SALVIR.png';
import logo2 from '../assets/Logo_SALVIR_letras.png';
import { FaFacebookF, FaInstagram, FaWhatsapp } from 'react-icons/fa';
import { Link } from "react-router-dom";

const Footer = () => {
    return (
        <section id="footer">
            <footer className="footer">
                <div className="footer-columns">
                    
                    {/* Columna 1: Misión y marca */}
                    <div className="footer-section">
                     <div className="navbar-logo">
                      <img src={logo} alt="Salvir Logo" className="logo" />
                      <img src={logo2} alt="Salvir Logo" className="logo2" />
                     </div>
                        <p className="footer-mission">
                            En Salvir te ayudamos a gestionar tu consultorio de forma simple, segura y desde un solo lugar.
                        </p>
                        <p className="footer-made-in">Hecho en México.</p>
                        <p>© 2026 All rights reserved.</p>
                    </div>

                    {/* Columna 2: Soporte */}
                    <div className="footer-section">
                        <h4>Soporte</h4>
                        <ul>
                            <li>
                               <a href="/terminos-y-condiciones"
                                   target="_blank"
                                   rel="noopener noreferrer">
                                   Términos y Condiciones
                                </a>
                            </li>
                            <li>
                                <a href="/aviso-de-privacidad"
                                   target="_blank"
                                   rel="noopener noreferrer">
                                   Aviso de Privacidad
                                </a>
                            </li>
                            <li>
                                <Link to="/seguridad">Seguridad de Datos</Link>
                            </li>
                            <li><Link to="/preguntas-frecuentes">Preguntas Frecuentes</Link></li>
                        </ul>
                    </div>

                    {/* Columna 3: Contacto */}
                    <div className="footer-section">
                        <h4>Contáctanos</h4>
                        <ul>
                            <li>Correo: contacto@salvir.com</li>
                            <li>Teléfono: (+52 1) 56 4481 1995</li>
                            
                        
                        </ul>
                        <div className="footer-social-icons">
                            <a href="https://www.facebook.com/profile.php?id=61577203054055&locale=es_LA" target="_blank" rel="noopener noreferrer"><FaFacebookF /></a>
                            <a href="https://www.instagram.com/salvir.mex/" target="_blank" rel="noopener noreferrer"><FaInstagram /></a>
                            <a href="https://wa.me/5215644811995" target="_blank" rel="noopener noreferrer" className="whatsapp-icon"> <FaWhatsapp /></a>
                        </div>
                    </div>
                </div>
            </footer>
        </section>
    );
};

export default Footer;
